import {FormControl, FormHelperText, MenuItem, Select, Stack, Typography} from '@mui/material';
import {Control, Controller, FieldPath, FieldValues} from 'react-hook-form';
import {IDeviceTypesDict} from '../../../../shared/types/deviceTypesDict.types';
import ControlledInput from '../../../../ui/controlled-input/ControlledInput';
import {DEVICE_FORM_FIELDS, LABEL_STYLE, REQUIRED_STYLE} from './constants';

interface Props<T extends FieldValues> {
  loading: boolean;
  deviceTypes: IDeviceTypesDict[];
  control: Control<T>;
}

export const DeviceModelFields = <T extends FieldValues>({loading, deviceTypes, control}: Props<T>): JSX.Element => {
  return (
    <>
      {DEVICE_FORM_FIELDS.map((field) => (
        <Stack direction="row" key={field.name}>
          <Stack direction="column" sx={{width: '100%'}} spacing={0.25}>
            <Stack direction="row" spacing={0.25}>
              <Typography sx={LABEL_STYLE} variant="subtitle2">
                {field.label}
              </Typography>
              {field.required && (
                <Typography sx={REQUIRED_STYLE} variant="subtitle2">
                  *
                </Typography>
              )}
            </Stack>

            {field.type === 'select' && (
              <Controller
                name={field.name as FieldPath<T>}
                control={control}
                rules={field.rules}
                render={({field: controllerField, fieldState: {error}}) => (
                  <FormControl>
                    <Select {...controllerField} size="small" error={!!error}>
                      {deviceTypes.map((option) => (
                        <MenuItem key={option.code} value={option.code}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText error>{error?.message ?? ''}</FormHelperText>
                  </FormControl>
                )}
              />
            )}

            {field.type === 'text' && (
              <ControlledInput
                control={control}
                name={field.name}
                disabled={loading}
                size="small"
                rules={field.rules}
              />
            )}
          </Stack>
        </Stack>
      ))}
    </>
  );
};
